export default "/images/pause-circle.svg?62885e6b1a9ac470d1d5f18d18f86c91";